import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
const firebaseConfig = {
    apiKey: "AIzaSyDVSUFBgG1iTUnwZ7JBus6zIovNMR6A1NY",
    authDomain: "r-wire.firebaseapp.com",
    databaseURL: "https://r-wire-default-rtdb.firebaseio.com",
    projectId: "r-wire",
    storageBucket: "r-wire.firebasestorage.app",
    messagingSenderId: "614864444194",
    appId: "1:614864444194:web:9685f606d62ca5af47a37b",
    measurementId: "G-P0FYR359R5"
  };
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };